<template>
  <div class="icon icon-file-upload" v-html="IconFileUpload"></div>
</template>
<script>
import IconFileUpload from './icon-file-upload.svg'
export default {
  data () {
    return {
      IconFileUpload: IconFileUpload
    }
  }
}
</script>
<style lang='scss'>
</style>



// WEBPACK FOOTER //
// uncommon-client/components/svgs/IconFileUpload.vue